import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const LABEL_MAP: Record<string, string> = {
  overview: 'Overview',
  cspm: 'CSPM',
  cwpp: 'CWPP',
  ciem: 'CIEM',
  dspm: 'DSPM',
  cdr: 'CDR',
  'ai-spm': 'AI SPM',
  'container-k8s': 'Containers & K8s',
  'attack-paths': 'Attack Paths',
  compliance: 'Compliance',
  accounts: 'Cloud Accounts',
  integrations: 'Integrations',
  issues: 'Issues',
  findings: 'Findings',
  inventory: 'Inventory',
  graph: 'Security Graph',
  policies: 'Policies',
  easm: 'EASM',
  remediation: 'Remediation',
  'cost-security': 'Cost & Security',
  notifications: 'Notifications',
  vulnerabilities: 'Vulnerabilities',
  rbac: 'RBAC',
  analytics: 'Analytics',
  workflows: 'Workflows',
  'runtime-protection': 'Runtime Protection',
  exposure: 'Exposure Management',
  settings: 'Settings',
  kspm: 'KSPM',
  'supply-chain': 'Supply Chain',
  'threat-center': 'Threat Center',
  'code-security': 'Code Security',
  engines: 'Engines',
  projects: 'Projects',
  connectors: 'Connectors',
  'audit-logs': 'Audit Logs',
  'cis-benchmarks': 'CIS Benchmarks',
  'custom-detectors': 'Custom Detectors',
  'trust-center': 'Trust Center',
  simulate: 'Attacker Simulation',
  'code-to-cloud': 'Code to Cloud',
  'custom-dashboard': 'Custom Dashboard',
};

const Breadcrumb: React.FC = () => {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 px-6 py-2 text-xs">
      <Link to="/" className="text-gray-400 hover:text-white transition-colors">
        Home
      </Link>
      {segments.map((seg, i) => {
        const path = '/' + segments.slice(0, i + 1).join('/');
        const label = LABEL_MAP[seg] || seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' ');
        const isLast = i === segments.length - 1;

        return (
          <React.Fragment key={path}>
            <ChevronRight className="w-3 h-3 text-gray-600" />
            {isLast ? (
              <span className="text-gray-300 font-medium">{label}</span>
            ) : (
              <Link to={path} className="text-gray-400 hover:text-white transition-colors">
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
